import React from 'react';
import { PropInfo, CodeExample, TabMenuProps } from '@cimpress/react-components';

import TabMenuCode from '!raw-loader!./tabMenu.jsx';
import TabMenuDemo from './tabMenu.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const TabMenuDocs = () => {
  const propInfos: PropInfo<TabMenuProps>[] = [
    {
      name: 'activeTabId',
      type: 'string',
      default: 'The first tab',
      description: 'The id of the currently active tab.',
    },
    {
      name: 'tabs',
      type: 'array (required)',
      default: '',
      description: (
        <p>
          The list of tabs to include in the menu. Tabs have the following shape: <br />
          <code>
            &#123;id: string (required), title: node (required), description: node, icon: node, body: node&#125
          </code>
          <br />
          The body is the content display when a tab is active.
          <br />
          To conform with UX best practices, icons and descriptions for tabs will be ignored if any tab is missing an
          icon or description, respectively.
        </p>
      ),
    },
    {
      name: 'tabGroups',
      type: 'array',
      default: '',
      description: (
        <p>
          Used for grouping sets of tabs together by tab id. Tab Groups have the following shape: <br />
          <code>&#123;label: string (required), tabIds: array (required)&#125</code>
          <br />
          To conform with UX best practices, the tab groups prop will be ignored if there is only one tab group or if
          there are any tabs that were not included in a tab group.
        </p>
      ),
    },

    {
      name: 'onTabClick',
      type: 'func',
      default: '',
      description: (
        <div>
          <p>If provided, a callback function to be called when a tab has been click.</p>
          <p>
            Signature: <code>function(event: object, tabId: string) {'=>'} void</code>
          </p>
          <p>
            <code>event:</code> The click event
          </p>
          <p>
            <code>tabId:</code> The clicked tab by id
          </p>
        </div>
      ),
    },

    {
      name: 'bodyStyle',
      type: 'object',
      default: '{}',
      description: 'Inline styles applied to the body of the Tab Menu.',
    },

    {
      name: 'tabStyle',
      type: 'object',
      default: '{}',
      description: 'Inline styles applied to the tab container of the Tab Menu.',
    },
  ];

  return (
    <ComponentDoc name="Tab Menu" propInfos={propInfos}>
      <TabMenuDemo />
      <CodeExample code={TabMenuCode} />
    </ComponentDoc>
  );
};

export default TabMenuDocs;
